import React from 'react';
import { ToolbarItem } from '@amzn/aac-chrome-internal-api';
import { ConsolidatedNavContextProvider } from 'src/providers/ConsolidatedNavContextProvider';
import { ConsolidatedSideNavInner } from './ConsolidatedSideNavInner';

interface ConsolidatedSideNavProps {
  toolbarItems: Array<ToolbarItem>;
}

export const ConsolidatedSideNav: React.VFC<ConsolidatedSideNavProps> = ({
  toolbarItems,
}) => (
  <ConsolidatedNavContextProvider initToolbarItems={toolbarItems}>
    <ConsolidatedSideNavInner />
  </ConsolidatedNavContextProvider>
);
